import React, { useEffect } from 'react'
import { ModalCloseIcon } from '~/components/icons'
import { useBreakpoint } from '~/hooks'
import { StyledFullPageModal, StyledFullPageModalContent } from './styled'
import { Props } from './types'

const FullPageModal: React.FC<Props> = ({
  visible,
  children,
  onClose,
  className = '',
  replace = false,
  showClose = true,
  hideBeacon = true,
}) => {
  const { isMobile } = useBreakpoint()

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return
    onClose?.(event as any)
  }

  const handleCloseClick = (event: React.MouseEvent<SVGSVGElement>) => {
    onClose?.(event as any)
  }

  const setBeaconVisible = (visible) => {
    if (!isMobile) return
    const beacon = document.getElementById('beacon-container')
    if (beacon) {
      beacon.style.display = visible ? 'block' : 'none'
    }
  }

  useEffect(() => {
    if (hideBeacon) {
      setBeaconVisible(!visible)
    }
    return () => {
      setBeaconVisible(true)
    }
  }, [visible])

  if (!visible) return null

  if (replace) {
    return <StyledFullPageModal onClick={handleOverlayClick}>{children}</StyledFullPageModal>
  }

  return (
    <StyledFullPageModal onClick={handleOverlayClick}>
      <StyledFullPageModalContent className={className}>
        {showClose && <ModalCloseIcon className="modal-close" onClick={handleCloseClick} />}
        {children}
      </StyledFullPageModalContent>
    </StyledFullPageModal>
  )
}

export default FullPageModal
